export default "__VITE_ASSET__CKUTq8lF__"